var React = require('react');

function AfiLogo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#058475;}")),React.createElement("g",{"id":"Capa_2","data-name":"Capa 2","key":1},React.createElement("g",{"id":"Layer_1","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M54.66,61.94H34.35V43.56A15.62,15.62,0,0,0,20.3,28V61.94H0V43.56A18.78,18.78,0,0,1,17.17,24.88V18.74a18.75,18.75,0,0,1,37.49,0ZM37.49,58.81h14V18.74a15.61,15.61,0,0,0-31.22,0v6.14A18.78,18.78,0,0,1,37.49,43.56Zm-34.36,0h14V28a15.64,15.64,0,0,0-14,15.53Z"})))]);
}

AfiLogo.defaultProps = {"viewBox":"0 0 54.66 61.94"};

module.exports = AfiLogo;

AfiLogo.default = AfiLogo;
